module.exports = __webpack_public_path__ + "img/20180815_151629_178.c594820a.jpg";